// extracted by mini-css-extract-plugin
export default {"productCode":"nNF2H","label":"HjoK9"};